import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { useTaskSummary } from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/hooks';
import { useTaskResourceEstimate } from './useTaskResourceEstimate';

const useOnChangeTaskResourceSuccess = ({
  taskResourceEstimateId,
  canViewCost,
  taskId
}) => {
  const {
    values: { resourceEstimates },
    setFieldValue
  } = useFormikContext();

  const { handleRefetchTaskSummary } = useTaskSummary({
    taskId
  });
  const { getTaskResourceEstimate } = useTaskResourceEstimate();

  return {
    onChangeTaskResourceSuccess: useCallback(
      async ({ newTaskResourceEstimateId }) => {
        const {
          taskResourceEstimate: newTaskResourceEstimate
        } = await getTaskResourceEstimate({
          resourceEstimateUri: newTaskResourceEstimateId,
          includeTaskResourceUserHoursProgressSummary: true,
          includeTaskResourceUserCostProgressSummary: canViewCost,
          includeTaskResourceUserAllocation: true
        });

        const updatedResourceEstimates = resourceEstimates.map(
          resourceEstimate => {
            return taskResourceEstimateId === resourceEstimate.id
              ? newTaskResourceEstimate
              : resourceEstimate;
          }
        );

        setFieldValue('resourceEstimates', updatedResourceEstimates);

        canViewCost && handleRefetchTaskSummary();
      },
      [
        getTaskResourceEstimate,
        resourceEstimates,
        setFieldValue,
        taskResourceEstimateId,
        handleRefetchTaskSummary
      ]
    )
  };
};

export default useOnChangeTaskResourceSuccess;
